import Shell from "../../../../components/specific/Shell.tsx";
import {User} from "../../../../api/accessControl/User.ts";
import {PrimaryButton} from "../../../../components/general/PrimaryButton.tsx";

export function WelcomePage({currentUser}: { currentUser: User }) {
    return <>
        <Shell currentUser={currentUser} isLoading={false}>
            <div className='max-w-xl mx-auto'>
                <h1 className="weight-600 text-4xl mb-6 ">Welkom! Je bent er klaar voor.</h1>
                <div className="">
                    <p className="mb-4">
                        Je onboarding is succesvol afgerond. Super! Vanaf nu kun je je bedrijf een boost geven met onze
                        heldere financiële inzichten, dashboards en nog veel meer.
                    </p>

                    <img src="/quinn-transparent.png" alt="" className={'h-64 mx-auto my-8'}/>

                    <h2 className="text-xl font-bold mb-2">Documenten delen? Dat kan ook! 📄</h2>
                    <p className="mb-4">
                        Verbeter ook het verzamelen van je documenten. Gebruik onze webapp of mobiele app om ze
                        eenvoudig te delen.
                    </p>

                    <h2 className="text-xl font-bold mb-2">Hoe werkt het precies? ⚙️</h2>
                    <ol className="list-decimal ml-6 mb-4 space-y-1"> {/* Added space-y-1 for list item spacing */}
                        <li>
                            <strong>Koppeling:</strong> We synchroniseren met de banken en bankrekeningen die je zojuist
                            hebt gekoppeld.
                        </li>
                        <li>
                            <strong>Importeren:</strong> Daarna maken we verbinding met je banken en halen we je
                            transacties realtime binnen.
                        </li>
                        <li>
                            <strong>Verwerken:</strong> Vervolgens gaan we aan de slag met deze transacties en maken we
                            overzichtelijke dashboards voor je aan.
                        </li>
                    </ol>

                    <h2 className="text-xl font-bold mb-2">Mis je iets? Laat het ons weten! 💡</h2>
                    <p> {/* No mb-4 needed if it's the last element */}
                        Heb je wensen of ideeën voor functies die we nog niet hebben? Neem contact met ons op. We horen
                        graag wat je denkt!
                    </p>

                    <PrimaryButton title={'Naar dashboard'} className={'mt-8'} onClick={() => {
                        window.location.replace('/');
                    }}/>
                </div>
            </div>

        </Shell>
    </>
}
